module.exports = __webpack_public_path__ + "img/b.5690d49f.png";